import { Component } from "@angular/core";
import { WorkerAccount } from "@salaxy/core";
import { SalaxyContext } from "../../../services/index";

/* tslint:disable */
/* TODO: Waiting for rewrite / final implementation */

/**
 * Provides a standard user interface to edit a worker object.
 * The current implementation is bound to SalaxyContext.workers.current.
 * If you need to bind the model to some other item, you need to extend this code.
 */
@Component({
    selector: "salaxy-worker-detail-edit",
    template: `<!-- TODO: Add back form validation -->

<div *ngIf="!(model?.avatar)">
    <p>
    Valitse työntekijä tai luo uusi: <button md-raised-button (click)="createNew()">Luo uusi</button>
    </p>
</div>
<div *ngIf="model?.avatar">
    <div *ngIf="!model.isReadOnly">
        <form name="workerForm" class="form-horizontal">
            <div class="salaxy-row">
                <div class="scol-6">
                    <h3>Henkilötiedot</h3>
                    <mat-input-container>
                        <input mdInput placeholder="Etunimi" name="avatar.firstName" required [(ngModel)]="model.avatar.firstName">
                    </mat-input-container>
                    <mat-input-container md-block>
                        <input mdInput placeholder="Sukunimi" name="avatar.lastName" required [(ngModel)]="model.avatar.lastName">
                    </mat-input-container><br />
                    <mat-input-container>
                        <input mdInput placeholder="Henkilötunnus" name="officialPersonId" required [(ngModel)]="model.officialPersonId">
                    </mat-input-container><br />
                    <mat-input-container>
                        <input mdInput placeholder="Sähköpostiosoite" name="contact.email" [(ngModel)]="model.contact.email">
                    </mat-input-container><br />
                    <mat-input-container>
                        <input mdInput placeholder="Puhelinnumero" name="contact.telephone" [(ngModel)]="model.contact.telephone">
                    </mat-input-container><br />
                    <mat-input-container>
                        <input mdInput placeholder="Katuosoite" name="contact.street" [(ngModel)]="model.contact.street">
                    </mat-input-container><br />
                    <mat-input-container>
                        <input mdInput placeholder="Postinumero" name="contact.postalCode" [(ngModel)]="model.contact.postalCode">
                    </mat-input-container>
                    <mat-input-container>
                        <input mdInput placeholder="Kaupunki" name="contact.city" [(ngModel)]="model.contact.city">
                    </mat-input-container>
                </div>
                <div class="scol-6">
                    <h3>Maksutiedot</h3>
                    <mat-input-container>
                        <input mdInput placeholder="Tilinumero" name="ibanNumber" [(ngModel)]="model.ibanNumber">
                    </mat-input-container><br />
                    <mat-select placeholder="Verokortin tyyppi" [(ngModel)]="model.workerInfo.defaultTaxCard.type" name="workerInfo.defaultTaxCard.type">
                        <mat-option value="example">Esimerkkiverokortti (kysy tieto myöhemmin)</mat-option>
                        <mat-option value="noTaxCard">Ei verokorttia (60%)</mat-option>
                        <mat-option value="sideIncome">Sivutulon verokortti</mat-option>
                        <mat-option value="taxCardA">Verokortti A</mat-option>
                        <mat-option value="taxCardB">Verokortti B</mat-option>
                        <mat-option value="freelancer">Freelancer</mat-option>
                        <mat-option value="others">Muut tyypit</mat-option>
                    </mat-select><br />
                    <mat-input-container>
                        <input mdInput placeholder="Veroprosentti" [(ngModel)]="model.workerInfo.defaultTaxCard.taxPercent" name="workerInfo.defaultTaxCard.taxPercent">
                    </mat-input-container><strong>%</strong>
                    <h3>Työntekijän poistaminen</h3>
                    <p>
                    <button (click)="delete()" name="delete" color="warn" type="button" md-raised-button>Poista</button>
                    </p>
                </div>
            </div>
            <div class="salaxy-row">
                <button (click)="save()" color="primary" name="submit" md-raised-button>Tallenna muutokset</button>
            </div>
        </form>
    </div>
    <div *ngIf="model.isReadOnly">
        <div class="salaxy-row">
            <div class="scol-6">
                <h3>Työntekijä on tunnistautunut pankkitunnuksin</h3>
                <p>
                Tämä työntekijä on kirjautunut Palkkaus.fi-palveluun ja hallinnoi itse omia henkilötietojaan. Myös verokorttia ja tilinumeroa.
                </p>
                <p>
                Jos näet vääriä tietoja, ole yhteydessä työntekijään tai ota yhteyttä asiakaspalveluumme.
                </p>
                <table>
                    <tr>
                        <td>Sähköposti:</td>
                        <td><a href="mailto:{{ model.contact.email }}">{{ model.contact.email }}</a></td>
                    </tr>
                    <tr>
                        <td>Puhelin:</td>
                        <td>{{ model.contact.telephone }}</td>
                    </tr>
                    <tr>
                        <td>Tilinumero:</td>
                        <td>{{ model.ibanNumber }}</td>
                    </tr>
                    <tr>
                        <td>Verokortin tyyppi:</td>
                        <td [ngSwitch]="model.workerInfo?.defaultTaxCard.type">
                            <span *ngSwitchCase="'example'">Esimerkkiverokortti (kysy tieto myöhemmin)</span>
                            <span *ngSwitchCase="'noTaxCard'">Ei verokorttia (60%)</span>
                            <span *ngSwitchCase="'sideIncome'">Sivutulon verokortti</span>
                            <span *ngSwitchCase="'taxCardA'">Verokortti A</span>
                            <span *ngSwitchCase="'taxCardB'">Verokortti B</span>
                            <span *ngSwitchCase="'freelancer'">Freelancer</span>
                            <span *ngSwitchDefault>Muu verokortti / tuntematon</span>
                        </td>
                    </tr>
                    <tr>
                        <td>Veroprosentti:</td>
                        <td>{{ model.workerInfo.defaultTaxCard.taxPercent || '-' }} %</td>
                    </tr>
                </table>
            </div>
        </div>
    </div>

</div>
`,
})
export class NgWorkerDetailEditComponent {

    constructor(private context: SalaxyContext) {
    }

    /** The WorkerAccount model that is edited. */
    public get model(): WorkerAccount {
        return this.context.workers.current;
    }

    /** Save the current model back to repository */
    public save() {
        this.context.workers.saveCurrent();
    }

    /**
     * Delete this item from repository.
     * Note that this may not always be possible. At least check model.isReadOnly
     */
    public delete() {
        if (this.model && this.model.id) {
            this.context.workers.delete(this.model.id);
        }
        this.context.workers.current = null;
    }

    /** Creates a new worker component to the currnt connection (does not commit to server yet). */
    public createNew() {
        return this.context.workers.newCurrent();
    }
}
